module.exports = __webpack_public_path__ + "static/media/PencilBackground640x960.1c4af870.jpg";